import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { adminPriceTableRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: adminPriceTableRow[] ;
  loading?: boolean;
};

const AdminPriceTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();



  const columns = useMemo(
    () => [
      {
        id: "lastUpdate",
        label: t("ADMIN_PRICE.TABLE.LAST_UPDATE"),
        minWidth: 120,
        align: "right",
      },
      {
        id: "basePrice",
        label: t("ADMIN_PRICE.TABLE.BASE_PRICE"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "UnitOfMeasure",
        label: t("ADMIN_PRICE.TABLE.UNIT_OF_MEASURE"),
        minWidth: 120,
        align: "right",
        format: (row: adminPriceTableRow) =>
          t(`ADMIN_PRICE.UNIT_VALUES.${row.UnitOfMeasure}`),
      },
      {
        id: "productName",
        label: t("ADMIN_PRICE.TABLE.PRODUCT_NAME"),
        minWidth: 140,
        align: "right",
        format: (row: adminPriceTableRow) => t(row.productName),
      },
      {
        id: "category",
        label: t("ADMIN_PRICE.TABLE.CATEGORY"),
        minWidth: 100,
        align: "right",
        format: (row: adminPriceTableRow) =>
          t(`ADMIN_PRICE.CATEGORY_VALUES.${row.category}`),
      }
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default AdminPriceTable;
